import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_CLIENT_CONFIG } from '../core/api-client-config';
import { PaginationResult } from '../core/pagination';
import { PortalUser } from '../models';

/**
 * Utenti registrati al portale, letti dal backoffice. `BackofficeUsers` è
 * un'altra cosa: quelli sono gli operatori interni.
 */
@Injectable({ providedIn: 'root' })
export class AdminPortalUsersApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${inject(API_CLIENT_CONFIG).apiBaseUrl}/api/admin/Users`;

  /** `name` cerca su nome e cognome insieme, non sull'email. */
  getUsers(options?: { name?: string; skip?: number; take?: number }) {
    let params = new HttpParams();

    if (options?.name) {
      params = params.append('name', options.name);
    }

    if (options?.skip !== null && options?.skip !== undefined) {
      params = params.append('skip', options.skip);
    }

    if (options?.take !== null && options?.take !== undefined) {
      params = params.append('take', options.take);
    }

    return this.httpClient.get<PaginationResult<PortalUser>>(
      `${this.baseUrl}`,
      {
        params,
      },
    );
  }
}
